import { c as _c } from "react/compiler-runtime";
import { getCountryNameFromCode } from '@onefootprint/core';
import type { Iso3166TwoDigitCountryCode } from '@onefootprint/request-types';
import type { CountrySpecificDocumentMapping, IdDocKind } from '@onefootprint/request-types/dashboard';
import { Flag, LinkButton } from '@onefootprint/ui';
import { Fragment, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
type ExistingCountryDocMappingsProps = {
  countryDocMappings: CountrySpecificDocumentMapping;
  editingCountry?: Iso3166TwoDigitCountryCode;
  editor: ReactNode;
  onEdit: (country: Iso3166TwoDigitCountryCode) => void;
};
const ExistingCountryDocMappings = t0 => {
  const $ = _c(15);
  const {
    onEdit,
    countryDocMappings,
    editingCountry,
    editor
  } = t0;
  const {
    t
  } = useTranslation("common");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "id_document"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t: docT
  } = useTranslation("common", t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      keyPrefix: "collectDocument.acceptedDocuments"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    t: tCountrySpecific
  } = useTranslation("playbook-builder", t2);
  let t3;
  if ($[2] !== countryDocMappings) {
    t3 = Object.keys(countryDocMappings);
    $[2] = countryDocMappings;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const existingCountries = t3;
  let t4;
  if ($[4] !== docT || $[5] !== tCountrySpecific) {
    t4 = docs => {
      if (docs.length === 0) {
        return tCountrySpecific(_temp);
      }
      return docs.map(doc => docT($_0 => $_0[doc])).join(", ");
    };
    $[4] = docT;
    $[5] = tCountrySpecific;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const getDocNames = t4;
  let t5;
  if ($[7] !== countryDocMappings || $[8] !== editingCountry || $[9] !== editor || $[10] !== existingCountries || $[11] !== getDocNames || $[12] !== onEdit || $[13] !== t) {
    t5 = <div className="flex flex-col gap-0.5">{existingCountries.map(country => country === editingCountry ? <Fragment key={country}>{editor}</Fragment> : <div key={country} className="grid items-center gap-2 pt-2 pb-2" style={{
        gridTemplateColumns: "24px auto 2fr 32px",
        gridTemplateAreas: "\"flag country docs link\""
      }}><div className="[grid-area:flag]"><Flag code={country as Iso3166TwoDigitCountryCode} /></div><div className="[grid-area:country] overflow-hidden"><div className="text-label-2 text-primary truncate">{getCountryNameFromCode(country)}:</div></div><div className="[grid-area:docs] overflow-hidden"><div className="text-body-2 text-primary truncate">{getDocNames(countryDocMappings[country] ?? [])}</div></div><div className="[grid-area:link]"><LinkButton onClick={() => onEdit(country as Iso3166TwoDigitCountryCode)}>{t(_temp2)}</LinkButton></div></div>)}</div>;
    $[7] = countryDocMappings;
    $[8] = editingCountry;
    $[9] = editor;
    $[10] = existingCountries;
    $[11] = getDocNames;
    $[12] = onEdit;
    $[13] = t;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};
export default ExistingCountryDocMappings;
function _temp($) {
  return $.noDocuments;
}
function _temp2($_1) {
  return $_1.edit;
}